import React, { useState } from "react";
import { toast } from "sonner";
import api from "../../../lib/api";
import { errText } from "../biz/i18n";
import { btnMain, inp } from "../biz/ui";
import { useLabT } from "./i18n";
import { TextIn, Check, pair } from "./fields";
import { Collapse } from "./QuestionBuilder";

const NAMES = { "United Arab Emirates": "الإمارات", "Saudi Arabia": "السعودية", Kuwait: "الكويت", Qatar: "قطر", Bahrain: "البحرين", Oman: "عُمان" };

export function LabSettings({ data, reload }) {
  const { t, lang } = useLabT();
  const [p, setP] = useState(data.settings);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setP((x) => ({ ...x, [k]: v }));
  const ships = p.shipping_countries || [];
  const setShip = (i, patch) => set("shipping_countries", ships.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  const save = async () => {
    setBusy(true);
    const { questions, application_questions, ...rest } = p;
    try { await api.put("/admin/lab/settings", rest); toast.success(t("saved")); reload(); } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return (
    <Collapse title={t("lab_settings")} testid="lab-settings">
      <div className="space-y-4">
        <p className="font-semibold text-sm">{t("shipping")}</p>
        <div className="space-y-2">
          {ships.map((r, i) => (
            <div key={r.country} className="border border-[#EEE5D8] rounded-xl p-3 space-y-2" data-testid={`lab-ship-${i}`}>
              <div className="flex items-center justify-between gap-3">
                <b className="text-sm">{lang === "ar" ? NAMES[r.country] : r.country}</b>
                <Check label={t("enabled_c")} checked={r.enabled} onChange={(v) => setShip(i, { enabled: v })} testid={`lab-ship-on-${i}`} />
              </div>
              {r.enabled && (
                <div className="flex flex-wrap items-center gap-3">
                  <Check label={t("use_site")} checked={r.use_site} onChange={(v) => setShip(i, { use_site: v })} testid={`lab-ship-site-${i}`} />
                  {!r.use_site && <input type="number" value={r.fee} onChange={(e) => setShip(i, { fee: e.target.value })} className={`${inp} !w-32 !py-2`} placeholder={t("custom_fee")} data-testid={`lab-ship-fee-${i}`} />}
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-3">
          <TextIn type="number" label={t("min_experiments")} value={p.min_experiments} onChange={(v) => set("min_experiments", v)} testid="lab-s-min" />
          <TextIn type="number" label={t("default_size_ml")} value={p.default_size_ml} onChange={(v) => set("default_size_ml", v)} testid="lab-s-size" />
        </div>
        <Check label={t("show_archive")} checked={p.show_archive} onChange={(v) => set("show_archive", v)} testid="lab-s-archive" />
        <div className="grid md:grid-cols-2 gap-3">
          <TextIn dir="ltr" label={t("title_set")} value={p.title_en} onChange={(v) => set("title_en", v)} testid="lab-s-title-en" />
          <TextIn dir="rtl" label={t("title_set_ar")} value={p.title_ar} onChange={(v) => set("title_ar", v)} testid="lab-s-title-ar" />
        </div>
        {pair(t, p, set, "intro", { area: true, rows: 6 })}
        {pair(t, p, set, "statement")}
        {pair(t, p, set, "disclaimer", { area: true })}
        {pair(t, p, set, "ip", { area: true, rows: 2 })}
        {pair(t, p, set, "safety_olfactory", { area: true, rows: 2 })}
        {pair(t, p, set, "safety_skin", { area: true, rows: 2 })}
        <button onClick={save} disabled={busy} className={btnMain} data-testid="lab-s-save">{t("save")}</button>
      </div>
    </Collapse>
  );
}
